const localeEs = {
  es: {
    CREHANA_FOR_BUSINESS: 'Crehana para empresas',

    SEO_DESCRIPTION:
      'Diseñamos entrenamiento ágil con profesionales de Google, Facebook, Amazon y más. Mejora las habilidades de tu equipo en diseño, data, transformación digital, softskills y más.',

    HERO_BANNER_BUTTON: 'Empieza tu prueba gratis',

    TERMS_1: 'Al solicitar la demo acepto los',
    TERMS_2: 'términos y condiciones',
    TERMS_3: 'de Crehana',

    FREE_TRIAL_BANNER_TITLE: 'Creer en tu equipo es ayudarlo a crecer',
    FREE_TRIAL_BANNER_DESCRIPTION:
      'Entrena a tu equipo de manera interactiva y cercana en nuestro ecosistema digital de aprendizaje.',
    FREE_TRIAL_BANNER_BUTTON: 'Empieza tu prueba gratis',

    ABOUT_SECTION__FEATURE_TITLE_1:
      'Nuestros cursos están disponibles a cualquier hora. ',
    ABOUT_SECTION__FEATURE_TITLE_2:
      'Accede a estadísticas en tiempo real para ver el progreso de tu equipo.',
    ABOUT_SECTION__FEATURE_TITLE_3:
      'Aprende con mentores expertos de la industria. ',

    BANNER_SECTION_FORM_EMAIL: 'Correo electrónico',
    BANNER_SECTION_FORM_EMAIL_ERROR: 'Ingresar un email válido',
    BANNER_SECTION_FORM_REQUIRED: 'Campo requerido',
    BANNER_SECTION_FORM_MAX_LENGTH: 'Máximo 50 caracteres',
    BANNER_SECTION_FORM_BUTTON: 'Comenzar',
    BANNER_SECTION_BENEFITS_1: 'Diagnóstica tu equipo',
    BANNER_SECTION_BENEFITS_2: 'Análisis en tiempo real',
    BANNER_SECTION_BENEFITS_3: 'Desarrolla tus skill',
    BANNER_SECTION_WHATSAPP_BUTTON_1: 'Pruébalo Gratis',
    BANNER_SECTION_WHATSAPP_BUTTON_2: 'Escríbenos',

    TRIAL_FORM_TITLE_1: 'para empresas',
    TRIAL_FORM_TITLE_2: 'Vive la experiencia durante 7 días',
    TRIAL_FORM_PROGRESS: 'Crea tu cuenta: Paso {{current}} de 3',
    TRIAL_FORM_FEATURE_TITLE: 'Vive la experiencia durante 7 días',
    TRIAL_FORM_FEATURE_DESCRIPTION:
      'Completa tu formulario para activar tu prueba gratuita 🎉',
    TRIAL_FORM_FEATURE_ITEM_1: 'Diagnóstica tu equipo',
    TRIAL_FORM_FEATURE_ITEM_2: 'Análisis en tiempo real',
    TRIAL_FORM_FEATURE_ITEM_3: 'Desarrolla tus kill',
    TRIAL_FORM_FEATURE_ITEM_4: 'Crea tu propio contenido',
    TRIAL_FORM_REQUIRED: 'Campo requerido',
    TRIAL_FORM_MAX_LENGTH: 'Máximo 70 caracteres',
    TRIAL_FORM_ERROR_EMAIL: 'Ingrese correo válido',
    TRIAL_FORM_STEP_1_TITLE:
      ' Vea como Crehana puede ayudarlo a desarrollar las habilidades y a crear tu propio contenido.',
    TRIAL_FORM_STEP_1_NAME: 'Nombre',
    TRIAL_FORM_STEP_1_LASTNAME: 'Apellido',
    TRIAL_FORM_STEP_1_EMAIL: 'Correo corporativo',
    TRIAL_FORM_STEP_1_BUTTON: 'Continuar',
    TRIAL_FORM_STEP_2_TITLE:
      'Cientos de compañías como la tuya están usando Crehana para empresas',
    TRIAL_FORM_STEP_2_COMPANY: 'Nombre de la empresa',
    TRIAL_FORM_STEP_2_EMPLOYEES: 'Número de empleados',
    TRIAL_FORM_STEP_2_ROLE: 'Puesto o cargo',
    TRIAL_FORM_STEP_2_BUTTON: 'Continuar',
    TRIAL_FORM_STEP_3_TITLE:
      'Cientos de compañías como la tuya están usando Crehana para empresas',
    TRIAL_FORM_STEP_3_PHONE: 'Número de teléfono',
    TRIAL_FORM_STEP_3_COUNTRY: 'País',
    TRIAL_FORM_STEP_3_BUTTON: 'Finalizar',
    TRIAL_FORM_STEP_3_COUNTRY_1: 'Perú',
    TRIAL_FORM_STEP_3_COUNTRY_2: 'Argentina',
    TRIAL_FORM_STEP_3_COUNTRY_3: 'México',
    TRIAL_FORM_STEP_3_COUNTRY_4: 'Colombia',
    TRIAL_FORM_STEP_3_COUNTRY_5: 'España',
    TRIAL_FORM_STEP_3_COUNTRY_6: 'Chile',
    TRIAL_FORM_STEP_3_COUNTRY_7: 'Otros',
    TRIAL_FORM_STEP_4_TITLE: '¡Muchas gracias por registrar \n tus datos!',
    TRIAL_FORM_STEP_4_SUBTITLE:
      'En breve nos estaremos comunicando \n contigo para que vivas esta experriencia.',

    TRIAL_FORM_COMPANY_TESTIMONIAL_TITLE: 'Equipos que crecen con nosotros',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_1:
      '“Cambió mi forma de ver el microaprendizaje”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_1:
      '“Las clases de Crehana me cambiaron la perspectiva del microaprendizaje, más bien la llamaría fragmentación visualmente ergonómica del conocimiento. Fácilmente puedes escuchar 50 minutos sin que los sientas.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_1:
      'Directora Regional de Talento Humano en SURA Asset Management',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_2:
      '“La experiencia con Crehana fue excelente”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_2:
      '“Nuestra experiencia con Crehana fue excelente. No solo por el contenido de la plataforma, también por el contacto y la flexibilidad que nos dieron para utilizar las licencias. Los cursos me gustaron mucho, el tiempo de cada parte fue perfecto y siento que los ejemplos y las explicaciones fueron muy buenas. La plataforma es amigable, fácil de usar e intuitiva.”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_2:
      'Coordinadora de Aprendizaje en Entel Perú.',
    TRIAL_FORM_TESTIMONIAL_SLIDER_TITLE_3:
      '“Crehana es un aliado para nuestro desarrollo”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_DESCRIPTION_3:
      '“Estamos muy agradecidos con la oportunidad, nuestros colaboradores la han recibido con mucho entusiasmo y motivación ya que los temas son muy buenos, actuales y aportan mucho al desarrollo de nuestra gente. Desde el punto de vista de HR, Crehana es un aliado estratégico para armar planes de desarrollo y capacitación, retención de talentos y reconocimientos e incentivos”',
    TRIAL_FORM_TESTIMONIAL_SLIDER_OCCUPATION_3: 'HR Manager en Bioderma.',

    COMPANIES_SECTION_TITLE: 'Equipos que crecen con nosotros',

    SOCIAL_VALIDATION_TITLE_1: 'Empresas que \n confían en nosotros',
    SOCIAL_VALIDATION_TITLE_2: 'Colaboradores \n aprendiendo',
    SOCIAL_VALIDATION_TITLE_3: 'Cursos en nuestras \n rutas de aprendizaje',

    BENEFITS_TITLE_1: 'Integración de Microsoft Teams',
    BENEFITS_DESCRIPTION_1:
      'Ten una mayor accesibilidad ingresando a tus cursos desde tu cuenta de Microsoft Teams',
    BENEFITS_TITLE_2: 'Skill XP',
    BENEFITS_DESCRIPTION_2:
      'Identifica cuál es tu nivel de conocimientos para potenciar tu aprendizaje y capacitarte en lo que necesitas.',
    BENEFITS_TITLE_3: 'Metodología en base a proyectos',
    BENEFITS_DESCRIPTION_3:
      'Aprendizaje continuo y flexible para poner en práctica tus nuevas habilidades de manera inmediata.',

    PERFORMANCE_BUTTON: 'Conocer más',

    LEARN_SECTION_FEATURE_1_NAME: 'Classrooms',
    LEARN_SECTION_FEATURE_1_DESCRIPTION:
      'Sube tu propio contenido y crea grupos para decidir quién puede ver los cursos de tu organización.',
    LEARN_SECTION_FEATURE_1_BUTOON: 'Conocer más',
    LEARN_SECTION_FEATURE_2_NAME: 'Desarrolla',
    LEARN_SECTION_FEATURE_2_DESCRIPTION:
      'Ya sea adquirir nuevas habilidades o desarrollar las que tienen, este es el lugar en el que las personas de tu equipo aprenden.',
    LEARN_SECTION_FEATURE_2_BUTOON: 'Conocer más',

    SKILL_IQ_SECTION_TITLE: 'Skill XP',
    SKILL_IQ_SECTION_BUTTON: 'Conocer más',

    TRACK_SECTION_TITLE: 'NUESTRA RUTA DE APRENDIZAJE',
    TRACK_SECTION_SUBTITLE_1: 'Aprende',
    TRACK_SECTION_SUBTITLE_2: 'de especialistas reconocidos en el mundo',
    TRACK_SECTION_BUTTON: 'Ver todas las rutas',
    TRACK_SECTION_TRACK_1_NAME: 'Ventas',
    TRACK_SECTION_TRACK_1_DESCRIPTION:
      'Gestiona eficiente y estratégicamente tus clientes para mejores resultados. Dale a tus clientes exactamente lo que buscan y construye relaciones duraderas.',
    TRACK_SECTION_TRACK_1_BUTTON: 'Ver Detalle de Ruta',
    TRACK_SECTION_TRACK_1_OCCUPATION: 'Account Manager en Google',
    TRACK_SECTION_TRACK_1_TITLE: 'Software que vas a aprender',
    TRACK_SECTION_TRACK_2_NAME: 'Liderazgo',
    TRACK_SECTION_TRACK_2_DESCRIPTION:
      'Conoce las habilidades que un buen líder debe desarrollar para crear una cultura de confianza e impulsar el crecimiento en su equipo.',
    TRACK_SECTION_TRACK_2_BUTTON: 'Ver Detalle de Ruta',
    TRACK_SECTION_TRACK_2_OCCUPATION: 'Life and executive Coach',
    TRACK_SECTION_TRACK_2_TITLE: '',
    TRACK_SECTION_TRACK_3_NAME: 'Innovación',
    TRACK_SECTION_TRACK_3_DESCRIPTION:
      'Aprende a implementar un proyecto de innovación en tu trabajo, con base en el diseño de servicios y Design Thinking para conocer a tu usuario.',
    TRACK_SECTION_TRACK_3_BUTTON: 'Ver Detalle de Ruta',
    TRACK_SECTION_TRACK_3_OCCUPATION: 'Diseño de Servicios & UX en Citibank',
    TRACK_SECTION_TRACK_3_TITLE: '',
    TRACK_SECTION_TRACK_4_NAME: 'E-commerce',
    TRACK_SECTION_TRACK_4_DESCRIPTION:
      'Crea tus propias estrategias de venta online, arma tu tienda en línea y crea un nuevo canal para transformar tu negocio.',
    TRACK_SECTION_TRACK_4_BUTTON: 'Ver Detalle de Ruta',
    TRACK_SECTION_TRACK_4_OCCUPATION: 'Sr Product Manager en Amazon',
    TRACK_SECTION_TRACK_4_TITLE: 'Software que vas a aprender',

    TESTIMONIAL_SECTION_1_TITLE: '“La experiencia con Crehana fue excelente”',
    TESTIMONIAL_SECTION_1_CONTENT:
      'Nuestra experiencia con Crehana fue excelente. No solo por el contenido de la plataforma, también por el contacto y la flexibilidad que nos dieron para utilizar las licencias. Los cursos me gustaron mucho, el tiempo de cada parte fue perfecto y siento que los ejemplos y las explicaciones fueron muy buenas. La plataforma es amigable, fácil de usar e intuitiva.',
    TESTIMONIAL_SECTION_1_OCCUPATION:
      'Coordinadora de Aprendizaje en Entel Perú.',
    TESTIMONIAL_SECTION_2_TITLE: '“Cambió mi forma de ver el microaprendizaje”',
    TESTIMONIAL_SECTION_2_CONTENT:
      'Las clases de Crehana me cambiaron la perspectiva del microaprendizaje, más bien la llamaría fragmentación visualmente ergonómica del conocimiento. Fácilmente puedes escuchar 50 minutos sin que los sientas.',
    TESTIMONIAL_SECTION_2_OCCUPATION:
      'Directora Regional de Talento Humano en SURA Asset Management',
    TESTIMONIAL_SECTION_3_TITLE:
      '“Crehana es un aliado para nuestro desarrollo”',
    TESTIMONIAL_SECTION_3_CONTENT:
      'Estamos muy agradecidos con la oportunidad, nuestros colaboradores la han recibido con mucho entusiasmo y motivación ya que los temas son muy buenos, actuales y aportan mucho al desarrollo de nuestra gente. Desde el punto de vista de HR, Crehana es un aliado estratégico para armar planes de desarrollo y capacitación, retención de talentos y reconocimientos e incentivos.',
    TESTIMONIAL_SECTION_3_OCCUPATION: 'HR Manager en Bioderma.',

    BLOG_SECTION_TITLE_1: 'Contenido',
    BLOG_SECTION_TITLE_2: 'que acompaña tu crecimiento',
    BLOG_SECTION_BUTTON: 'Ir al Blog',

    VIDEO_SECTION_TITLE_HIGHLIGHT: 'Aprendiendo juntos,',
    VIDEO_SECTION_TITLE: 'crecemos todos',
    VIDEO_SECTION_DESCRIPTION:
      'Crehana para empresas es un partner estratégico que le ayuda a tu organización a superar los desafíos aprendizaje y comunicación a través de la educación.',
    VIDEO_SECTION_BUTTON: 'Pruébalo Gratis',

    DOWNLOADABLE_CARD_DETAIL: 'Ver detalle',
    DOWNLOADABLE_DOWNLOADS: 'descargas',

    SOCIAL_NOTIFICATION_TITLE: '¡Se ha unido a Crehana!',
  },
};

export default localeEs;
